var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { waitMusicApi } from 'apis/waitMusic';
import { getAsyncStatusFromRtkQueryStates } from 'utils/apis/axios';
import { useAppPathParams } from 'utils/url/useAppPathParams';
import { FileUsagePage } from '../../components/fileUsagePage/fileUsagePage';
export const SettingsAudioWaitMusic = () => {
    const { id } = useAppPathParams('/settings/audio/wait-music/:id');
    const [getWaitMusicUsage, _a] = waitMusicApi.useLazyReadWaitMusicUsageQuery(), { data } = _a, rtkQueryState = __rest(_a, ["data"]);
    const asyncStatus = getAsyncStatusFromRtkQueryStates(rtkQueryState);
    useEffect(() => {
        getWaitMusicUsage({ id });
    }, [getWaitMusicUsage, id]);
    // Hack to get the wait music name:
    // The wait music usage response doesn't have the name of the music, so find it
    // in the list of all music (the read music response should be cached).
    const { data: musicData } = waitMusicApi.useReadWaitMusicQuery();
    const musicList = musicData === null || musicData === void 0 ? void 0 : musicData.data.wait_music;
    const waitMusic = musicList === null || musicList === void 0 ? void 0 : musicList.find((music) => music.id === id);
    const defaultHoldMusic = data === null || data === void 0 ? void 0 : data.data.default_hold_music;
    const flowUsage = (data === null || data === void 0 ? void 0 : data.data.flow_usage) || [];
    const usage = defaultHoldMusic
        ? [
            {
                id: 'default',
                name: 'Default hold music',
                active: true,
                updated_at: 'n/a',
            },
            ...flowUsage,
        ]
        : flowUsage;
    return (_jsx(FileUsagePage, { type: "wait-music", usage: usage, file: waitMusic, asyncStatus: asyncStatus }));
};
